import React, {useEffect, useState} from 'react';
import {Button, Form, Input, InputGroup, InputGroupAddon, Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import {student_strings} from "../../translations/student_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import ClassPlanTableRow from "../Tables/ClassPlanItemTableRow";
import {MdAdd, MdDone, MdDelete} from 'react-icons/md';
import Card from "reactstrap/es/Card";
import Row from "reactstrap/es/Row";
import resourceHelper from "../../helpers/ResourceHelper";
import CPTableRow from "../Tables/CPTableRow";
import Col from "reactstrap/es/Col";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);

const ClassPlanView = (props) => {
    const [classPlan, setClassPlan] = useState(props.classPlan);
    const [editing, setEditing] = useState(false);
    const [titleInput, setTitleInput] = useState(props.classPlan.title);
    const [newItemTitle, setNewItemTitle] = useState("");
    const [updatedTimes, setUpdatedTimes] = useState(props.classPlanViewUpdated);
    const [classPlans, setClassPlans] = useState(props.classPlans);
    const [showClassPlanList, setShowClassPlanList] = useState(false);
    const [showReuseOptions, setShowReuseOptions] = useState(false);

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    useEffect(() => {
        if (props.classPlanViewUpdated !== updatedTimes) {
            setUpdatedTimes(props.classPlanViewUpdated)
            setClassPlan(props.classPlan)
            setClassPlans(props.classPlans)
        }
    });

    const renderTableData = () => {
        return classPlan.class_plan_items.map((item, index) => {
            return (
                <ClassPlanTableRow item={item} key={item.id}
                                   deleteClassPlanItem={deleteClassPlanItem}/>
            )
        })
    };

    const selectClassPlanFromList = (event, cp) => {
        event.preventDefault();
        props.reuseClassPlan(cp);
    }

    function renderClassPlanTableData() {
        return classPlans.map((item, index) => {
            return (
                <CPTableRow item={item} key={item.id}
                            onSelected={selectClassPlanFromList}/>
            )
        })
    };

    function deleteClassPlanItem(e, item) {
        e.preventDefault();
        props.removeCPI(classPlan, item.id)
    }

    localize();

    const handleChange = (event) => {
        if (event.target.id == "input-new-item") {
            setNewItemTitle(event.target.value)
        } else if (event.target.id == "input-cp-title") {
            setTitleInput(event.target.value)
        }
    };

    const startCreatingClassPlan = (event) => {
        event.preventDefault();
        setEditing(true);
    };

    const showClassPlans = (event) => {
        event.preventDefault();
        setShowClassPlanList(true);
    };

    function handlePublicChange(e) {
        e.preventDefault();
        props.updateClassPlanPublic(classPlan, e.target.checked);
    }

    function updateCPTitle(e) {
        e.preventDefault();
        setEditing(false);

        classPlan.title = titleInput;
        props.updateClassPlanTitle(classPlan);
    }

    function addCPItem(e) {
        e.preventDefault();
        props.addCPI(classPlan, newItemTitle);
        setNewItemTitle("");
    }

    function deleteCP(e) {
        e.preventDefault();
        props.deleteCP(classPlan);
        setClassPlan(resourceHelper.emptyClassPlan())
    }

    function toggleReuseOptions(e) {
        e.preventDefault();

        setShowReuseOptions(!showReuseOptions)
    }

    function reuseFor(e, type) {
        props.reuseFor(e, type);
        setShowReuseOptions(false);
    }

    return (
        <Card className="bg-white shadow p-4 mb-4">
            <div>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => props.closeView()}
                >
                    <span className="text-red" aria-hidden={true}>×</span>
                </button>
                <small className="font-weight-600">{resourceStrings.class_plan_expl}</small>
                {(!classPlan.id && !editing) &&
                <>
                    <div className="mt-2" style={{
                        width: "100%", display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <Button
                            color="warning"
                            onClick={e => startCreatingClassPlan(e)}
                            size="lg"
                        >
                            {resourceStrings.create_class_plan}
                        </Button>
                        {classPlans.length > 0 &&
                        <Button
                            color="info"
                            onClick={e => showClassPlans(e)}
                            size="lg"
                        >
                            {resourceStrings.reuse_class_plan}
                        </Button>}
                    </div>

                    {showClassPlanList == true &&
                    <div>
                        <Table
                            className="align-items-center table-light table-flush mt-2"
                            responsive
                        >
                            <tbody>
                            {renderClassPlanTableData()}
                            </tbody>
                        </Table>
                    </div>}
                </>
                }
            </div>
            {(classPlan.id != null || editing == true) &&
            <div className="mt-2">
                <hr/>
                {editing == false && classPlan.title && classPlan.title.length > 0 ?
                    (<h2 className="text-default" onClick={e => setEditing(!editing)}>{classPlan.title}</h2>)
                    :
                    (<div className="mb-2">
                        <InputGroup className="input-group-alternative">
                            <Input
                                defaultValue={classPlan.title}
                                id="input-cp-title"
                                onChange={handleChange}
                                placeholder={resourceStrings.title} type="text"/>

                            {titleInput.length > 0 &&
                            <InputGroupAddon addonType="append">
                                <Button color="success" size="sm" onClick={e => updateCPTitle(e)}
                                        style={{width: "4rem"}}>
                                    <MdDone/>
                                </Button>
                            </InputGroupAddon>
                            }
                        </InputGroup>
                    </div>)
                }
                {classPlan.id &&
                <>
                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                        <input
                            className="custom-control-input"
                            id="input-public-cb"
                            onChange={e => handlePublicChange(e)}
                            checked={classPlan.public == true}
                            type="checkbox"
                        />
                        <label className="custom-control-label" htmlFor="input-public-cb">
                            {resourceStrings.public}
                        </label>
                    </div>

                    <small className="font-weight-900">{resourceStrings.class_plan_items_header}</small>
                    <div>
                        {classPlan.class_plan_items.length > 0 &&
                        <Table
                            className="align-items-center table-light table-flush mt-2"
                            responsive
                        >
                            <tbody>
                            {renderTableData()}
                            </tbody>
                        </Table>
                        }
                    </div>
                    <div className="mt-2 mb-2">
                        <Form role="form">
                            <InputGroup className="input-group-alternative">
                                <Input
                                    id="input-new-item"
                                    value={newItemTitle}
                                    onChange={handleChange}
                                    placeholder={resourceStrings.class_plan_items_add} type="textarea"/>

                                {newItemTitle.length > 0 &&
                                <InputGroupAddon addonType="append">
                                    <Button color="success" size="sm" onClick={e => addCPItem(e)}
                                            style={{width: "4rem"}}>
                                        <MdAdd/>
                                    </Button>
                                </InputGroupAddon>
                                }
                            </InputGroup>
                        </Form>
                    </div>
                </>
                }

                {classPlan.id &&
                <Row>
                    <Col>
                        <Button className="mt-2" color="secondary" size="lg" onClick={e => deleteCP(e)}>
                            <MdDelete/>
                        </Button>
                    </Col>

                    <Col>

                        {showReuseOptions == true &&
                        <div>
                            <Button className="mt-2" color="info" size="sm" onClick={e => reuseFor(e, "today")}>
                                {resourceStrings.class_plan_reuse_for_all_today + ` (${props.classDate})`}
                            </Button>
                            <Button className="mt-2" color="info" size="sm" onClick={e => reuseFor(e, "today_ct")}>
                                {resourceStrings.formatString(resourceStrings.class_plan_reuse_for_all_today_class_type, "'" + props.className + "'") + ` (${props.classDate})`}
                            </Button>
                            <Button className="mt-2" color="warning" size="sm" onClick={e => reuseFor(e, "week")}>
                                {resourceStrings.class_plan_reuse_for_all_this_week}
                            </Button>
                            <Button className="mt-2" color="warning" size="sm" onClick={e => reuseFor(e, "week_ct")}>
                                {resourceStrings.formatString(resourceStrings.class_plan_reuse_for_all_this_week_class_type, "'" + props.className + "'")}
                            </Button>
                        </div>
                        }

                        <Button className="mt-2" color="secondary" size="lg" onClick={e => toggleReuseOptions(e)}>
                            {showReuseOptions == true ? commonStrings.cancel : resourceStrings.class_plan_reuse_for}
                        </Button>
                    </Col>
                </Row>
                }
            </div>
            }
        </Card>
    );
};

export default ClassPlanView;